import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Button, Stack, Text } from '@mantine/core';
import { useIntl } from 'react-intl';

import { addressValidationMessages } from './address-validation-messages';
import { VALIDATED_ADDRESS_STATUS } from '../../../../../../../address';

import type { AddressValidationResultItem } from '../../../../../../../address';

type ValidationIssueAlertProps = {
  result: AddressValidationResultItem;
  isValidating: boolean;
  onValidate: () => void;
};

export const ValidationIssueAlert = ({ result, isValidating, onValidate }: ValidationIssueAlertProps) => {
  const intl = useIntl();
  const isError = result.status === VALIDATED_ADDRESS_STATUS.ERROR;
  const alertIcon = isError ? faCircleExclamation : faTriangleExclamation;
  const alertColor = isError ? 'red' : 'yellow';
  const message = result.messages[0] ?? (isError ? intl.formatMessage(addressValidationMessages.validationNetworkError) : '');

  return (
    <Alert
      color={alertColor}
      icon={<FontAwesomeIcon icon={alertIcon} />}
      title={intl.formatMessage(addressValidationMessages.validationError)}
    >
      <Stack gap='xs'>
        {message ? <Text size='sm'>{message}</Text> : null}
        <Button disabled={isValidating} onClick={onValidate} variant='tertiary'>
          {intl.formatMessage(addressValidationMessages.revalidateButton)}
        </Button>
      </Stack>
    </Alert>
  );
};
